import mitt from 'mitt'
export const dialogEvent = mitt()
// export default emitter

